export default {"src":"/_next/static/media/manax.8870b1e4.svg","height":600,"width":600,"blurWidth":0,"blurHeight":0};